import { render, staticRenderFns } from "./lrf-tabs.vue?vue&type=template&id=90ab1b7c&scoped=true"
import script from "./lrf-tabs.vue?vue&type=script&lang=js"
export * from "./lrf-tabs.vue?vue&type=script&lang=js"
import style0 from "./lrf-tabs.vue?vue&type=style&index=0&id=90ab1b7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_675154ded190a7e2d3ad9efb69cc05e3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ab1b7c",
  null
  
)

export default component.exports